import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, DollarSign, Calendar, Star } from 'lucide-react';
export function BonusThree() {
  return <section className="w-full py-16 px-6 border-t" style={{
    backgroundColor: 'white',
    borderColor: 'var(--light-navy)'
  }} data-id="element-270">
      <div className="max-w-2xl mx-auto" data-id="element-271">
        <div className="flex items-center gap-2 mb-8" data-id="element-272">
          <span className="px-3 py-1 rounded text-xs font-bold tracking-wider uppercase" style={{
          backgroundColor: 'var(--navy)',
          color: 'var(--gold)'
        }} data-id="element-273">
            Bono #3
          </span>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-8" data-id="element-274">
          <h2 className="font-serif text-3xl md:text-4xl mb-2" style={{
          color: 'var(--navy)'
        }} data-id="element-275">
            "Mini Kit 'Pago Extra' por Paycheck"
          </h2>
          <p className="text-xl font-medium mb-6" data-id="element-276">
            Valor: <span className="line-through opacity-50" data-id="element-277">$47</span> —{' '}
            <span style={{
            color: 'var(--gold)'
          }} data-id="element-278">
              Tuyo GRATIS
            </span>
          </p>

          <img src="https://cdn.magicpatterns.com/uploads/uhCQ4vNqafhd2Gd8nwDRW3/BONO_3_-_MINI_KIT_PAGO_EXTRA_POR_PAYCHECK_-_PLANTILLA_2B_RITUAL_DE_7_MIN.png" alt="Mini Kit Pago Extra por Paycheck" className="w-full rounded-xl shadow-lg mb-8" data-id="element-279" />

          <h3 className="font-bold text-xl mb-4" style={{
          color: 'var(--navy)'
        }} data-id="element-280">
            La intención no baja deudas. La ejecución sí.
          </h3>
          <p className="text-lg mb-6" style={{
          color: 'var(--charcoal)',
          lineHeight: '1.7'
        }} data-id="element-281">
            Querés pagar más. Lo sabés. Pero cada vez que cobrás pasa lo mismo:
            No sabés con certeza cuánto es "seguro" pagar extra sin quedarte
            corto. Entonces esperás a "ver qué sobra." Casi nunca sobra.
          </p>
          <p className="text-lg mb-8" style={{
          color: 'var(--charcoal)',
          lineHeight: '1.7'
        }} data-id="element-282">
            Este bono te da ese número. En 7 minutos. Cada vez que cobrás.
          </p>
        </motion.div>

        {/* Protection Table */}
        <div className="mb-10 overflow-x-auto" data-id="element-283">
          <h4 className="font-bold text-lg mb-4" style={{
          color: 'var(--navy)'
        }} data-id="element-284">
            Cómo el sistema te protege primero:
          </h4>
          <table className="w-full text-left border-collapse min-w-[500px]" data-id="element-285">
            <thead data-id="element-286">
              <tr style={{
              borderBottom: '2px solid var(--light-navy)'
            }} data-id="element-287">
                <th className="py-3 font-bold" style={{
                color: 'var(--navy)'
              }} data-id="element-288">
                  Qué protege primero
                </th>
                <th className="py-3 font-bold" style={{
                color: 'var(--navy)'
              }} data-id="element-289">
                  Por qué
                </th>
              </tr>
            </thead>
            <tbody className="text-sm md:text-base" data-id="element-290">
              <tr className="border-b border-gray-100" data-id="element-291">
                <td className="py-3 font-medium" data-id="element-292">
                  1. Bills hasta próximo cobro
                </td>
                <td className="py-3 opacity-80" data-id="element-293">
                  Para no atrasarte en ningún pago fijo
                </td>
              </tr>
              <tr className="border-b border-gray-100" data-id="element-294">
                <td className="py-3 font-medium" data-id="element-295">
                  2. Variable mínimo (comida/gas)
                </td>
                <td className="py-3 opacity-80" data-id="element-296">
                  Para cubrir lo básico sin stress
                </td>
              </tr>
              <tr className="border-b border-gray-100" data-id="element-297">
                <td className="py-3 font-medium" data-id="element-298">3. Buffer (colchón)</td>
                <td className="py-3 opacity-80" data-id="element-299">
                  Para no volver a la tarjeta por mini emergencias
                </td>
              </tr>
              <tr className="font-bold bg-green-50" data-id="element-300">
                <td className="py-3 pl-2" style={{
                color: 'var(--green)'
              }} data-id="element-301">
                  4. Pago extra seguro
                </td>
                <td className="py-3" style={{
                color: 'var(--green)'
              }} data-id="element-302">
                  Lo que queda después de proteger todo
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="bg-gray-50 p-6 rounded-xl mb-10" data-id="element-303">
          <h4 className="font-bold text-lg mb-4" style={{
          color: 'var(--navy)'
        }} data-id="element-304">
            El Ritual de 7 Minutos:
          </h4>
          <ol className="space-y-3 list-decimal pl-5" data-id="element-305">
            <li className="pl-2" data-id="element-306">
              Ves saldo real disponible (sin pending/holds)
            </li>
            <li className="pl-2" data-id="element-307">Anotás bills hasta el próximo cobro</li>
            <li className="pl-2" data-id="element-308">Reservás variable mínimo (comida + gas)</li>
            <li className="pl-2" data-id="element-309">Definís tu buffer (colchón de seguridad)</li>
            <li className="pl-2 font-bold" style={{
            color: 'var(--navy)'
          }} data-id="element-310">
              Calculás pago extra seguro con la fórmula
            </li>
            <li className="pl-2 font-bold" style={{
            color: 'var(--navy)'
          }} data-id="element-311">
              Ejecutás el pago ese mismo día
            </li>
            <li className="pl-2" data-id="element-312">
              Registrás + mini refuerzo (tachar, celebrar)
            </li>
          </ol>
        </div>

        <div className="mb-8" data-id="element-313">
          <h4 className="font-bold text-lg mb-4" style={{
          color: 'var(--navy)'
        }} data-id="element-314">
            Lo que incluye:
          </h4>
          <ul className="space-y-3" data-id="element-315">
            <li className="flex gap-3" data-id="element-316">
              <CheckCircle className="w-5 h-5 flex-shrink-0 mt-0.5" style={{
              color: 'var(--green)'
            }} data-id="element-317" />
              <span data-id="element-318">Plantilla Google Sheet con fórmulas automáticas</span>
            </li>
            <li className="flex gap-3" data-id="element-319">
              <CheckCircle className="w-5 h-5 flex-shrink-0 mt-0.5" style={{
              color: 'var(--green)'
            }} data-id="element-320" />
              <span data-id="element-321">Checklist "Payday Ritual" (printable)</span>
            </li>
            <li className="flex gap-3" data-id="element-322">
              <CheckCircle className="w-5 h-5 flex-shrink-0 mt-0.5" style={{
              color: 'var(--green)'
            }} data-id="element-323" />
              <span data-id="element-324">3 ejemplos completos con números reales</span>
            </li>
            <li className="flex gap-3" data-id="element-325">
              <CheckCircle className="w-5 h-5 flex-shrink-0 mt-0.5" style={{
              color: 'var(--green)'
            }} data-id="element-326" />
              <span data-id="element-327">Tabla de ajustes por frecuencia de cobro</span>
            </li>
            <li className="flex gap-3" data-id="element-328">
              <CheckCircle className="w-5 h-5 flex-shrink-0 mt-0.5" style={{
              color: 'var(--green)'
            }} data-id="element-329" />
              <span data-id="element-330">Sección especial para ingreso variable</span>
            </li>
          </ul>
        </div>

        <div className="p-6 rounded-xl border border-dashed" style={{
        borderColor: 'var(--navy)',
        backgroundColor: 'var(--light-navy)'
      }} data-id="element-331">
          <p className="font-medium text-center" style={{
          color: 'var(--navy)'
        }} data-id="element-332">
            Un pago extra consistente puede reducir años de deuda a meses.
          </p>
        </div>
      </div>
    </section>;
}